import { makeStyles, Text } from "@fluentui/react-components";
import CookieConsent from "react-cookie-consent";
import { dolphinTokens } from "../utils/Theme";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    container: {
        alignItems: "center !important",
        backgroundColor: `${dolphinTokens.colorDarkBlue} !important`
    },
    text: {
        margin: 0,

        "& a": {
            color: `white !important`,
            textDecoration: "underline !important"
        }
    },
    acceptButton: {
        backgroundColor: "white !important",
        color: `${dolphinTokens.colorDarkBlue} !important`,
        padding: "10px 20px !important",
        borderRadius: "5px !important",

        "@media (min-width: 436px)": {
            display: "block !important",
            margin: ".75rem auto 0 auto !important",
            transform: "translateX(-8px) !important",
        }
    },
    declineButton: {
        display: "none !important"
    }
});

export default function Consent() {
    const { t } = useTranslation("general");
    const styles = useStyles();

    return (
        <CookieConsent enableDeclineButton flipButtons
            location="bottom"
            buttonText="Close"
            expires={5}
            cookieName="user_cookie_consent"
            containerClasses={styles.container}
            buttonClasses={styles.acceptButton}
            acceptOnScroll={true}
            declineButtonClasses={styles.declineButton}
            >
            <Text block as="p" size={400} className={styles.text}>
                {t("cookies.text1")}
            </Text>
            <Text block as="p" size={400} className={styles.text}>
                {t("cookies.text2")}
            </Text>
        </CookieConsent>
    );
}